import { formatUTCTime } from "../../../global/utils/unixToLocalTime";
import { getOptionLabel, renderPrice, termOptions } from "../../../utils/Common";

export const PurchaseItemsColumns = ({ showUsedColumns = false } = {}) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);
  return [
    {
      title: "No",
      dataIndex: "ItemNo",
      key: "ItemNo",
      hidden: !isSystemUser,
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Item",
      dataIndex: "ItemName",
      key: "ItemName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Code",
      dataIndex: "CodeName",
      key: "CodeName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Term",
      dataIndex: "Term",
      key: "Term",
      render: (value) => getOptionLabel(termOptions, value),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: renderPrice,
    },
    ...(showUsedColumns
      ? [
          {
            title: "Used Mac",
            dataIndex: "UsedMac",
            key: "UsedMac",
            onHeaderCell: () => ({ onClick: () => {} }),
          },
          {
            title: "Used Time",
            dataIndex: "UsedTime",
            key: "UsedTime",
            render: (text) => (text ? formatUTCTime(text) : ""),
            onHeaderCell: () => ({ onClick: () => {} }),
          },
        ]
      : []),
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
    },
  ];
};
